import DateFormat from "examples/ReuseFunctions/DateFormat";

interface StatusTrackerParams {
  previousData: string | null;
  message: string;
  statusName: string;
  status_id: number;
  createdby: string | number;
  employeeName: string;
  employeePhone: string;
  arraivalDate?: string;
}

const StatusTracker = ({
  previousData,
  message,
  statusName,
  status_id,
  createdby,
  employeeName,
  employeePhone,
  arraivalDate,
}: StatusTrackerParams) => {
  const currentTime = DateFormat();

  const newEntry = {
    message,
    status: statusName,
    status_id,
    employeeName,
    employeePhone,
    createdby,
    Date: arraivalDate ?? currentTime,
  };

  const flattenData = (data: any[]): any[] =>
    data.flatMap((item) => (Array.isArray(item) ? flattenData(item) : item));

  const historyDataArray = previousData
    ? flattenData(JSON.parse(previousData))
    : [];
  historyDataArray.push(newEntry);

  return JSON.stringify(historyDataArray);
};

export default StatusTracker;
